/**
 * Site-wide copy & contact details. Centralised so the strings can move
 * into `i18n/{pt,en}.json` cleanly later. Until then, sections fall back
 * to their own defaults if a key is missing.
 */

export interface PlaceLocation {
  label: string;
  address: string[];
  hint?: string;
  marginNote?: string;
}

export interface SiteContent {
  brand: {
    name: string;
    tagline: string;
    handTag: string;
  };
  contact: {
    email: string;
    visiting: string;
  };
  donation: {
    iban: string;
    ibanHolder: string;
    mbway: string;
    mbwayMessage: string;
  };
  place: {
    locations: PlaceLocation[];
    footnote: string;
  };
  social: {
    instagram: string;
    facebook: string;
  };
  legal: {
    nipc: string;
    year: number;
  };
}

export const SITE: SiteContent = {
  brand: {
    name: 'Patinhas Sem Lar',
    tagline: 'Silvalde · Associação de Proteção Animal',
    handTag: '— um caderno',
  },
  contact: {
    email: 'geral@patinhassemlar.org',
    visiting: 'Fim de semana · 9h – 11h30 (voluntariado)',
  },
  donation: {
    iban: 'PT50 0045 1371 4026 1082 5454 1',
    ibanHolder: 'Titular: Associação Patinhas Sem Lar — Silvalde, Espinho.',
    mbway: '933 843 593 · 938 465 633',
    mbwayMessage: 'mensagem: "PSL · o teu nome"',
  },
  place: {
    locations: [
      {
        label: 'Canil',
        address: ['Rua do Calvário, 411', '4500-619 Silvalde, Espinho', 'Portugal'],
        hint:
          'A entrada é pelo portão entre os ecopontos e o 411 — segue o latido. Voluntariado e visitas ao fim de semana de manhã; outras alturas por marcação.',
        marginNote: '— entre os ecopontos e o 411.',
      },
      {
        label: 'Gatil',
        address: ['Rua do Golfe, 1877', '4500-389 Espinho', 'Portugal'],
        hint:
          'Os gatos vivem no nosso espaço em Espinho. Voluntariado ao fim de semana de manhã; visitas por marcação.',
        marginNote: '— a poucos minutos do canil.',
      },
    ],
    footnote: 'aprox. 3 km da praia · 25 min do Porto',
  },
  social: {
    instagram: 'https://www.instagram.com/patinhassemlar/',
    facebook: 'https://www.facebook.com/patinhassemlar/?locale=pt_PT',
  },
  legal: {
    nipc: 'NIPC 000 000 000',
    year: 2026,
  },
};
